import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { inlineLoaderFactory } from '@rx-applications/shared/utils';

export const TRANSLATION_SCOPE = 'resetPassword';

export const translationProvider = {
  provide: TRANSLOCO_SCOPE,
  useValue: {
    scope: TRANSLATION_SCOPE,
    loader: inlineLoaderFactory((lang: string) => import(`./${lang}.json`)),
  },
};
